import React from "react";
import { useRouter } from "next/navigation";
import { WeekCard } from "@aph/ui-lib-humanx";
import { ClusterItem, ClusterList } from "@/components/PagePiller/api/interface";
import { DeviceInfo } from "@/interface/deviceInfo";
import Slider, { Slide } from "@/components/Slider";
import IconRight from "$/icons/icon-right.svg";
import IconLeft from "$/icons/icon-left.svg";
import routes from "@/helpers/router";
import { RegisterRefType } from "@/components/PageHome/interfaces";
import SegmentInfoSelector from "@/redux/slice/auth/selectors/userSegmentInfo";
import { useAppSelector } from "@/redux/hooks";
import { assetClickedEvent } from "@/helpers/TSDEvents";
import { getPlainTexts } from "@/helpers";
import { NON_ONBOARDED_STATUS, ONBOARDING_STATUS } from "@/helpers/constants";
import styles from "./ClusterList.module.scss";

interface ClusterListProps {
  data: ClusterList;
  userAgent: DeviceInfo;
  registerRef?: RegisterRefType;
  assetPosition?: number;
}

const ClusterListComponent: React.FC<ClusterListProps> = ({ data, userAgent, registerRef, assetPosition }) => {
  const { clustersList, Title: title } = data;
  const { isMobile, isDesktop } = userAgent;

  const router = useRouter();
  const SegmentInfoObject = useAppSelector(SegmentInfoSelector);

  const handleClick: (slug: string) => void = (slug) => {
    router.push(routes.cluster(slug));
  };

  return (
    <section
      data-ref_id={data?.refId}
      ref={(el) => {
        if (data?.ShowHeadingInIndex && registerRef && data?.refId) registerRef(data?.refId, el);
      }}
      className={`scrollMargin spacingBetweenSections`}
    >
      {title && <div className={`container ${styles.title}`} dangerouslySetInnerHTML={{ __html: title }} />}
      <div className={`${styles.sliderWrapper} container ${isMobile ? styles.hidden : ""}`}>
        <Slider
          autoplay={false}
          slidesToShow={isMobile ? 1.5 : 6}
          columnGap={16}
          showArrows={isDesktop}
          showDots={false}
          overflow={isMobile ? "visible" : "hidden"}
          nextArrow={<IconRight className={`${styles.arrows} ${styles.arrowNext}`} />}
          prevArrow={<IconLeft className={`${styles.arrows} ${styles.arrowPrev}`} />}
        >
          {clustersList.map((cluster: ClusterItem, index) => {
            const { Name, Slug } = cluster;

            return (
              <Slide index={index} key={Slug}>
                <WeekCard
                  redirectUrl={routes.cluster(Slug)}
                  onClick={() => {
                    assetClickedEvent({
                      asset_name: getPlainTexts(title),
                      asset_display_text: Name,
                      asset_position: assetPosition,
                      asset_element_position: index + 1,
                      momverse_stage: SegmentInfoObject?.type
                        ? (ONBOARDING_STATUS[SegmentInfoObject?.type] ?? "")
                        : NON_ONBOARDED_STATUS,
                    });
                    handleClick(Slug);
                  }}
                  title={Name}
                  isRightIcon
                />
              </Slide>
            );
          })}
        </Slider>
      </div>
    </section>
  );
};

export default ClusterListComponent;
